import React, { useState, FormEvent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form'

import svgWait2 from '../svg/wait2.gif'


import { FbsConfig } from '../Types'
import { SystemHeader } from '../CommonUI';

import { transpileModule } from 'typescript';
import { stringify } from 'querystring';

var showFeeSection:boolean = true ;
var showDividendSection:boolean = true ;
var showFRRSection:boolean = true ;
var showStampReturnSection:boolean = true ;
var showAutopaySection:boolean = true ;


interface PageInfo {
    n: number
}

var GsbFlag: any;


interface FbsxConfigViewProps {
    gsb: AxiosInstance,
    FbsxConfig: FbsConfig,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}



function FbsxConfigView({ gsb, FbsxConfig = {} as FbsConfig, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: FbsxConfigViewProps) {

    const [isDeletePress, setisDeletePress] = useState(false)

    const [userKey, setuserKey] = useState("DEMO")
    const [dateFormat, setdateFormat] = useState("1")


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                setuserKey(GsbFlag.user_key)
                setdateFormat(GsbFlag.dateFormat)
            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, FbsxConfig ])



    if (! ("d_tr_date" in FbsxConfig)) return null



    return (
        <div>
            <div className="Row">
                <Button className="Col-1-1" disabled={true} icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                <Button className="Col-2-1" disabled={true} icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" disabled={true} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>

                <Button className="Col-5-1" disabled={true} icon="direction-right" onClick={() => onNextRec()} >Next</Button>
             
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="User Key">
                    <div id="DispText" >{userKey}</div>
                </FormGroup>
                <FormGroup className="Col-3-2" label="System Date Format">
                    {/* dateFormat === "0" && <div id="DispText" >YYYY-MM-DD</div> }
                    { dateFormat === "1" && <div id="DispText" >DD-MM-YYYY</div> }
                    { dateFormat === "2" && <div id="DispText" >MM-DD-YYYY</div> */}
                    <div id="DispText" >DD-MMM_YYYY</div> 
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Transaction Date">
                    <InputGroup readOnly value= {utils.dispDate(FbsxConfig.d_tr_date, dateFormat)} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Next Transaction Date">
                    <InputGroup readOnly value= {utils.dispDate(FbsxConfig.d_Next_tr_date, dateFormat)} />
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-5" label="Segregated Bank">
                    <InputGroup readOnly value={FbsxConfig.d_SegBank} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label=" Year Start Month ( 1 - 12 )">
                    <InputGroup readOnly value={utils.formatNumber2(FbsxConfig.d_YR_start)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Interest Calculation (Y=Use Prime Rate) " labelFor="inputInterest_Cal">
                    <RadioGroup
                        name="d_Interest_Cal"
                        disabled={true}
                        inline={true}
                        selectedValue={FbsxConfig.d_Interest_Cal}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Exposure Limit Method" labelFor="inputExpLimMeth">
                    <RadioGroup
                        name="d_ExpLimMeth"
                        disabled={true}
                        inline={true}
                        selectedValue={FbsxConfig.d_ExpLimMeth}
                        onChange={(s) => { }}
                    >
                        <Radio label="1= no. of HSI Contract(s)" value="1" />
                        <Radio label="2= Exposure Limit Amount"  value="2" />
                    </RadioGroup>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="User Time Out (No. of Hour)">
                    <InputGroup readOnly value={utils.formatNumber2(utils.StringToNum(FbsxConfig.x_AUTO_TIMEOUT))} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-5" label="Alternative Data Backup Folder">
                    <InputGroup readOnly value={FbsxConfig.x_BKUPPATH3} />
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />

            <div className="Spacing-V-16" />
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col3-1-2" label="Theme for Production" >
                    <InputGroup readOnly value={FbsxConfig.d_theme1} />
                    { FbsxConfig.d_theme1 === "0" && <div id="DispText" >Basic </div> }
                    { FbsxConfig.d_theme1 === "8" && <div id="DispText" >Dark </div> }
                    { FbsxConfig.d_theme1 === "1" && <div id="DispText" >Theme 1 </div> }
                    { FbsxConfig.d_theme1 === "2" && <div id="DispText" >Theme 2 </div> }
                    { FbsxConfig.d_theme1 === "3" && <div id="DispText" >Theme 3 </div> }
                    { FbsxConfig.d_theme1 === "4" && <div id="DispText" >Theme 4 </div> }
                    { FbsxConfig.d_theme1 === "5" && <div id="DispText" >Theme 5 </div> }
                    { FbsxConfig.d_theme1 === "6" && <div id="DispText" >Theme 6 </div> }
                    { FbsxConfig.d_theme1 === "7" && <div id="DispText" >Theme 7 </div> }
                </FormGroup>
             </div>     
             <div className="Row">
                <FormGroup className="Col3-1-2" label="Theme for Try / Other" >
                    <InputGroup readOnly value={FbsxConfig.d_theme2} />
                    { FbsxConfig.d_theme2 === "0" && <div id="DispText" >Basic </div> }
                    { FbsxConfig.d_theme2 === "8" && <div id="DispText" >Dark </div> }
                    { FbsxConfig.d_theme2 === "1" && <div id="DispText" >Theme 1 </div> }
                    { FbsxConfig.d_theme2 === "2" && <div id="DispText" >Theme 2 </div> }
                    { FbsxConfig.d_theme2 === "3" && <div id="DispText" >Theme 3 </div> }
                    { FbsxConfig.d_theme2 === "4" && <div id="DispText" >Theme 4 </div> }
                    { FbsxConfig.d_theme2 === "5" && <div id="DispText" >Theme 5 </div> }
                    { FbsxConfig.d_theme2 === "6" && <div id="DispText" >Theme 6 </div> }
                    { FbsxConfig.d_theme2 === "7" && <div id="DispText" >Theme 7 </div> }
                </FormGroup>
             </div>   
        </div>
    )
}

interface FbsxConfigEditProps {
    gsb: AxiosInstance,
    FbsxConfig?: FbsConfig,
    isNew?: boolean,
    onSave?: (FbsxConfig: FbsConfig) => void,
    onCancel?: () => void;
}

// onChange={utils.handleStringChange(s => setAc(prevState => Object.assign(prevState, {acName1: s})))}
function FbsxConfigEdit({ gsb, FbsxConfig = {} as FbsConfig, isNew = false, onSave = () => { }, onCancel = () => { } }: FbsxConfigEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FbsConfig>()


    const [userKey, setuserKey] = useState("DEMO")
    const [dateFormat, setdateFormat] = useState("1")
    const [def_d_theme1, setdef_d_theme1] = useState(FbsxConfig.d_theme1)
    const [def_d_theme2, setdef_d_theme2] = useState(FbsxConfig.d_theme2)

    const [SegBankValue, setSegBankValue] = useState(FbsxConfig.d_SegBank)
    const [YR_startValue, setYR_startValue] = useState(utils.numToString(FbsxConfig.d_YR_start))
    const [Interest_CalMethValue, setInterest_CalMethValue] = useState(FbsxConfig.d_Interest_Cal)
    const [ExpLimMethValue, setExpLimMethValue] = useState(FbsxConfig.d_ExpLimMeth)
  
    const [Auto_TimeoutValue, setAuto_TimeoutValue] = useState(FbsxConfig.x_AUTO_TIMEOUT)
    const [BKUPPATH3Value, setBKUPPATH3Value] = useState(FbsxConfig.x_BKUPPATH3)


    useEffect(() => {
        // Call reset to set default values if ac is passed
        if ("d_tr_date" in FbsxConfig) {
            reset(FbsxConfig)
        }
    }, [FbsxConfig, reset])

    
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                setuserKey(GsbFlag.user_key)
                setdateFormat(GsbFlag.dateFormat)

            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, FbsxConfig])


    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        //register({ name: "d_status" })
    }, [register])

    
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
    

    if (! isNew && !("d_tr_date" in FbsxConfig)) return null


    const onSubmit = (data: FbsConfig) => {
        //console.log("onsubmit called", data)

        // put value to json/field before write database dbf

        
        data.d_SegBank = SegBankValue;
        data.d_YR_start = utils.StringToNum(YR_startValue);
        data.d_Interest_Cal = Interest_CalMethValue;
        data.d_ExpLimMeth = ExpLimMethValue;

        data.x_AUTO_TIMEOUT = Auto_TimeoutValue;
        data.x_BKUPPATH3 = BKUPPATH3Value;

        //data.d_Enter2Tab = def_Enter2Tab


        ;
        (async () => {
            try {
                //console.log("call FbsxConfigedit data", data)
                //console.log("call FbsxConfigedit isNew", isNew)
                const res = await gsb.post('/fbs/Master', {sb_data: data, cPgmId: "FbsxConfig", cAction: "FbsxConfigValidate", isNew: isNew})
                //console.log("FbsxConfigedit res.data.ok", res.data.ok)
                //console.log("FbsxConfigedit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }
                    return
                }

                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()


    }



    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                {/*<Button className="Col-2-1" icon="undo" onClick={() => reset(ac)}>Reset</Button>*/}
                {/*<Button className="Col-3-1" icon="tick" type="submit">Save</Button>*/}
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="User Key">
                    <div id="DispText" >{userKey}</div>
                </FormGroup>
                <FormGroup className="Col-3-2" label="System Date Format">
                    {/* dateFormat === "0" && <div id="DispText" >YYYY-MM-DD</div> }
                    { dateFormat === "1" && <div id="DispText" >DD-MM-YYYY</div> }
                    { dateFormat === "2" && <div id="DispText" >MM-DD-YYYY</div> */}
                    <div id="DispText" >DD-MMM_YYYY</div> 
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Transaction Date">
                    {/* <InputGroup readOnly value= {utils.dispDate(FbsxConfig.d_tr_date, dateFormat)} /> */}
                    <InputGroup id="inputTrDate" name="d_tr_date" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-3-2" label="Next Transaction Date">
                    {/* <InputGroup readOnly value= {utils.dispDate(FbsxConfig.d_Next_tr_date, dateFormat)} /> */}
                    <InputGroup id="inputNextTrDate" name="d_Next_tr_date" disabled type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-5" label="Segregated Bank">
                    <InputGroup id="inputSegBank" defaultValue={SegBankValue} value={SegBankValue} onChange={utils.handleStringChange(n => setSegBankValue(n))} inputRef={register({ maxLength: 50 }) }/>
                    {errors.d_SegBank && errors.d_SegBank.type === "maxLength" && <span id="Err_msg">Max length is 50</span>}
                    {errors.d_SegBank && errors.d_SegBank.types && <span id="Err_msg">{errors.d_SegBank.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label=" Year Start Month ( 1 - 12 )">
                    <InputGroup id="inputYR_start" defaultValue={YR_startValue} value={YR_startValue} onChange={utils.handleStringChange(n => setYR_startValue(n))} />
                    {errors.d_YR_start && errors.d_YR_start.types && <span id="Err_msg">{errors.d_YR_start.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Interest Calculation (Y=Use Prime Rate) " labelFor="inputInterest_Cal">
                    <RadioGroup
                        name="d_Interest_Cal"
                        inline={true}
                        selectedValue={Interest_CalMethValue}
                        onChange={utils.handleStringChange(s => setInterest_CalMethValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_Interest_Cal && errors.d_Interest_Cal.types && <span id="Err_msg">{errors.d_Interest_Cal.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Exposure Limit Method" labelFor="inputExpLimMeth">
                    <RadioGroup
                        name="d_ExpLimMeth"
                        inline={true}
                        selectedValue={ExpLimMethValue}
                        onChange={utils.handleStringChange(s => setExpLimMethValue(s)) }
                        ref={register}
                    >
                        <Radio label="1= no. of HSI Contract(s)" value="1" />
                        <Radio label="2= Exposure Limit Amount"  value="2" />
                    </RadioGroup>
                    {errors.d_ExpLimMeth && errors.d_ExpLimMeth.types && <span id="Err_msg">{errors.d_ExpLimMeth.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="User Time Out (No. of Hour)">
                    <InputGroup id="inputAuto_Timeout" defaultValue={Auto_TimeoutValue} value={Auto_TimeoutValue} onChange={utils.handleStringChange(n => setAuto_TimeoutValue(n))} />
                    {errors.x_AUTO_TIMEOUT && errors.x_AUTO_TIMEOUT.type === "min" && <span id="Err_msg">Hour of User Time Out sholud Unit Amount be greater than 0 </span>}
                    {errors.x_AUTO_TIMEOUT && errors.x_AUTO_TIMEOUT.types && <span id="Err_msg">{errors.x_AUTO_TIMEOUT.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-5" label="Alternative Data Backup Folder">
                    <InputGroup id="inputBKUPPATH3" defaultValue={BKUPPATH3Value} value={BKUPPATH3Value} onChange={utils.handleStringChange(n => setBKUPPATH3Value(n))} />
                    {errors.x_BKUPPATH3 && errors.x_BKUPPATH3.types && <span id="Err_msg">{errors.x_BKUPPATH3.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />

            <div className="Spacing-V-16" />
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col3-1-2" label="Theme for Production" labelFor="inputd_theme1">
                    <select  id="inputd_theme1" name="d_theme1" value={def_d_theme1} onChange={utils.handleStringChange(s => setdef_d_theme1(s)) }ref={register}>
                        <option value="0">0: Basic </option>
                        <option value="8">8: Dark </option>
                        <option value="1">1: Theme 1</option>
                        <option value="2">2: Theme 2</option>
                        <option value="3">3: Theme 3</option>
                        <option value="4">4: Theme 4</option>
                        <option value="5">5: Theme 5</option>
                        {/*
                        <option value="6">6: Theme 6</option>
                        <option value="7">7: Theme 7</option>
                        */}
                    </select>
                    {errors.d_theme1 && errors.d_theme1.types && <span id="Err_msg">{errors.d_theme1.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-2" label="Theme for Try / Other" labelFor="inputd_theme2">
                    <select  id="inputd_theme2" name="d_theme2" value={def_d_theme2} onChange={utils.handleStringChange(s => setdef_d_theme2(s)) }ref={register}>
                        <option value="0">0: Basic </option>
                        <option value="8">8: Dark </option>
                        <option value="1">1: Theme 1</option>
                        <option value="2">2: Theme 2</option>
                        <option value="3">3: Theme 3</option>
                        <option value="4">4: Theme 4</option>
                        <option value="5">5: Theme 5</option>
                        {/*
                        <option value="6">6: Theme 6</option>
                        <option value="7">7: Theme 7</option>
                        */}
                    </select>
                    {errors.d_theme2 && errors.d_theme2.types && <span id="Err_msg">{errors.d_theme2.types.message}</span>}
                </FormGroup>
            </div>
            {/*
            <div className="Row">
                <FormGroup className="Col-1-2" label="Enter to next input field" labelFor="inputEnter2Tab">
                    <RadioGroup
                        name="d_Enter2Tab"
                        inline={true}
                        selectedValue={def_Enter2Tab}
                        onChange={utils.handleStringChange(s => setdef_Enter2Tab(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                    {errors.d_Enter2Tab && errors.d_Enter2Tab.types && <span id="Err_msg">{errors.d_Enter2Tab.types.message}</span>}
                </FormGroup>
            </div>
            */}

        
        </form>
    )
}

interface FbsxConfigMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function FbsxConfigMain({ gsb }: FbsxConfigMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [data, setData] = useState([] as FbsConfig[])


    const [searchKey, setSearchKey] = useState("OpenDate")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)
    const [showButton, setshowButton] = useState(false)


    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("Detail")
    const [currentAc, setCurrentAc] = useState({} as FbsConfig)
    const [BlankAc, setBlankAc] = useState({} as FbsConfig)


    const [currentMode, setCurrentMode] = useState("show")

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    

    
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    //gsb default value
    //BlankAc.d_p_Pref = "P"



    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("FbsxConfigMain disp user_key: ", res.data.Flag.user_key)
                //console.log("FbsxConfigMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("FbsxConfigMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("FbsxConfigMain disp GsbFlag: ", GsbFlag)
                //console.log("FbsxConfigMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("FbsxConfigMain disp dateFormat: ", dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("FbsxConfigMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("FbsxConfigMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("FbsxConfigMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key) ;

                //console.log("FbsxConfigMain isProduction: ", GsbFlag.isProduction)
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                //console.log("set StatusList: ", StatusList)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, currentMode])


    useEffect(() => {

        console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }


    }, [gsb, GsbFlag, cardOpen01, currentMode])


    useEffect(() => {

        setnPage(1)
        if ( nPage > 0 ) {
            //setcPrintMode("PS")
        } 

        (async () => {
            try {
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "FbsxConfig",
                        cAction: "ListRec",
                    });
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }

                console.log("main res.data", res.data.data)
                console.log("main currentAc", currentAc)
                setCurrentMode("show")

                setshowButton(false)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])



    const PrevRecProcess = async (FbsxConfig: FbsConfig) => {
/*        
        try {
            //console.log("call PrevRecProcess", ac)
            const res = await gsb.post('/fbs/Master', {sb_data: ac, cPgmId: "FbsxConfig", cAction: "PrevRec"})
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const DeleteProcess = async (FbsxConfig: FbsConfig) => {
/*        
        try {
            //console.log("call DeleteProcess", ac)
            const res = await gsb.post('/fbs/Master', {sb_data: ac, cPgmId: "FbsxConfig", cAction: "DelRec"})
            showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const NextRecProcess = async (FbsxConfig: FbsConfig) => {
/*        
        try {
            //console.log("call NextRecProcess", ac)
            const res = await gsb.post('/fbs/Master', {sb_data: ac, cPgmId: "FbsxConfig", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }


    const newOnSave = async (FbsxConfig: FbsConfig) => {
/*        
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ac, cPgmId: "FbsxConfig", cAction: "AddRec"})
            showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record added")

            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const editOnSave = async (FbsxConfig: FbsConfig) => {
        try {
            console.log("call editOnSave", FbsxConfig)
            const res = await gsb.post('/fbs/Master', {sb_data: FbsxConfig, cPgmId: "FbsxConfig", cAction: "UpdateRec"})
            //showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record saved")
/*            
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
*/            
            //setCurrentAc(res.data.data)
            showSuccess("FBSx Configuration Record Saved")
            setCurrentAc(res.data.data[0])
            setCurrentMode("show")

        } catch (error) {
            utils.showError(error)
        }
    }



    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail = <FbsxConfigView gsb={gsb} FbsxConfig={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ></FbsxConfigView>
    switch (currentMode) {
        case "edit":
            detail = <FbsxConfigEdit gsb={gsb} FbsxConfig={currentAc} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></FbsxConfigEdit>
            break
        case "new":
            detail = <FbsxConfigEdit gsb={gsb} FbsxConfig={BlankAc} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></FbsxConfigEdit>
            break
    }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let list = <>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>    

    return (
        <>
            <form >
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>FBSx Configuration</H3>
                    {/*
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                    */}

                    {detail}
                </Card>
            </form>
        </>
    );
}

export default FbsxConfigMain